<template>
	<v-modal>
		<template v-slot:header>
			<h1>To Do</h1>
		</template>
		<v-tabs ref="tabs" :tabless="true">
			<v-tab id="to-do" label="To Do">
				<table>
					<thead>
						<tr>
							<th align="center" class="actions"><span>Complete</span></th>
							<th align="left">To Do</th>
							<th align="left">Due</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(todo, toDoIndex) in todos" :key="toDoIndex">
							<td align="center">
								<input :value="todo.completed_at !== null" type="checkbox"/>
							</td>
							<td align="left" v-html="todo.description"/>
							<td align="left" v-html="$present('dateTime', todo.due_at)"/>
						</tr>
					</tbody>
				</table>
			</v-tab>
			<v-tab id="create-to-do" label="Create To Do">
				<form>
					<fieldset>
						<div>
							<div class="sr-only">
								<legend><span>New To-Do</span></legend>
							</div>
							<div>
								<label><span class="sr-only">To-Do </span>
									<div v-if="form.errors.get('description')" class="error-block">
										<p v-html="form.errors.get('description')"></p>
									</div>
									<input v-model="form.data.description" type="text"/>
								</label>
								<label><span class="sr-only">Due</span>
									<v-datepicker
										v-model="form.data.due_at" :inline="true" :min-date="new Date()" class="v-datepicker--wide"
										value=""/>
								</label>
							</div>
						</div>
					</fieldset>
				</form>
			</v-tab>
		</v-tabs>
		<template v-slot:footer>
			<ul class="actions">
				<template v-if="!creating">
					<li>
						<button
							class="button button--primary" @click.prevent="refs.tabs.goToTab('create-to-do')">New To Do
						</button>
					</li>
				</template>
				<template v-else>
					<li>
						<button
							class="button button--secondary" @click.prevent="refs.tabs.goToTab('to-do')">Cancel
						</button>
					</li>
					<li>
						<process-button
							:processing="form.processing" class="button button--primary" text="Create To-Do"
							@click.prevent="create()"/>
					</li>
				</template>
			</ul>
		</template>
	</v-modal>
</template>
<script>
import VDatepicker from "../../../../../common/components/v-datepicker/v-datepicker.vue";

export default {
	components: {
		VDatepicker,
	},

	data() {
		return {
			form: this.newForm({
				description: null,
				due_at: null,
			}),
		};
	},

	computed: {
		creating() {
			return this.refs.tabs?.isTabSelected("create-to-do");
		},
	},

	props: {
		todos: {
			required: true,
			type: Array,
		},
		newTab: {
			required: true,
			type: Boolean,
		},
		url: {
			required: true,
			type: String,
		},
		then: {
			required: true,
			type: Function,
		},
	},

	methods: {
		create() {
			this.form.post(this.url).then(response => {
				this.then(response);
			});
		},
	},

	mounted() {
		if (this.newTab) {
			this.refs.tabs.goToTab("create-to-do");
		}
	},
};
</script>
